// extracted by mini-css-extract-plugin
module.exports = {"button":"ControlsButton_button__1lzdO","active":"ControlsButton_active__zIW49","disabled":"ControlsButton_disabled__1JV_5"};